<template>
    <div
        :id="id"
        class="search-preference__reset"
    >
        <button
            class="pt-ui-btn"
            @click="provider.resetSettings"
        >
            {{ $t('Search.propver.reset') }}
        </button>
    </div>
</template>

<script>
import snakeCase from 'lodash/snakeCase';

export default {
    inject: ['store', 'provider'],
    computed: {
        id() {
            return [
                'bio_setting',
                this.searchType,
                'reset',
            ].map(snakeCase).join('-');
        },
    },
};
</script>
